import React, { createContext, useLayoutEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { LAYOUT_TYPE_IN_POPUP } from '../../constants/lw';

import { hasPublisherAnchor } from '../../helpers/dom';
import * as commonSelectors from '../../redux/selectors/common';

type ScrollMap = {
  firstEnter: boolean;
  map: Record<string, number>;
};

export const ScrollContext = createContext<ScrollMap>({
  firstEnter: true,
  map: {},
});

type Props = {
  children: React.ReactNode;
};

function ScrollObserverProvider({ children }: Props) {
  const mapRef = useRef<ScrollMap>({
    firstEnter: true,
    map: {},
  });

  const location = useLocation();
  const layout = useSelector(commonSelectors.layoutSelector);

  useLayoutEffect(() => {
    const writeScrollPosition = () => {
      mapRef.current.map[location.pathname] = window.scrollY;
    };

    if (layout !== LAYOUT_TYPE_IN_POPUP && !hasPublisherAnchor()) {
      window.addEventListener('scroll', writeScrollPosition);
    }

    return () => {
      window.removeEventListener('scroll', writeScrollPosition);
    };
  }, [location.pathname, layout]);

  return <ScrollContext.Provider value={mapRef.current}>{children}</ScrollContext.Provider>;
}

export default ScrollObserverProvider;
